// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `MatchProvisionStatus`.
const MatchProvisionStatus = __t.enum("MatchProvisionStatus", {Provisioning: __t.unit(),
  Ready: __t.unit(),
  InProgress: __t.unit(),
  Completed: __t.unit(),
  Failed: __t.unit(),
});

export default MatchProvisionStatus;


